<script setup lang="ts">
import { useI18n } from 'vue-i18n'
import { session } from '@/lib/auth'
import Banner from '@/ui/Banner.vue'
import ThreeCanvas from '@/ui/three/ThreeCanvas.vue'
import { scenes } from '@/ui/three/scenes'

defineProps<{ perm: string }>()
const { t } = useI18n()
</script>

<template>
  <div class="grid max-w-[640px] gap-2 pt-2">
    <ThreeCanvas :scene="scenes.shapes" :options="{ count: 3 }" class="h-36 w-full" />
    <h2 class="text-[15px] font-semibold">{{ t('shell.forbidden.title') }}</h2>
    <Banner tone="warning">
      {{ t('shell.forbidden.body', { role: t(`roles.${session.user?.role}`, session.user?.role ?? ''), perm }) }}
    </Banner>
  </div>
</template>
